import React, { Fragment, useState, useEffect } from 'react';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Typography from '@material-ui/core/Typography';
import styled from 'styled-components';

import home_an_pan from '../../../photos/home_an_pan.jpg';
import home_cookies_first from '../../../photos/home_cookies_first.jpg';
import home_cookies_second from '../../../photos/home_cookies_second.jpg';
import assortment_1 from '../../../photos/assortment_1.jpg';
import home_cookies_first_big from '../../../photos/home_cookies_first_big.png';
import home_cookies_second_big from '../../../photos/home_cookies_second_big.png';
import home_chiffon_cake from '../../../photos/home_chiffon_cake.jpg';
import colors from '../../../styles/colors';

const Banner = styled.div`
    ${props => props.theme.breakpoints.down('xs')} {
        height: 50vh;
    }
    ${props => props.theme.breakpoints.up('sm')} {
        height: calc(100vh - 80px);
    }
    background-size: cover;
    background-repeat: no-repeat;
    width: 100%;
`;

const BannerText = styled.div`
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: ${colors.white}
`;

const imagesForBigScreen = [home_cookies_first_big, home_an_pan, home_cookies_second_big];
const imagesForSmallScreen = [home_cookies_first, assortment_1, home_an_pan, home_chiffon_cake, home_cookies_second];

const PhotosCarousel = () => {

    const [indexBig, setIndexBig] = useState(0);
    const [indexSmall, setIndexSmall] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setIndexBig(prevIndexBig => prevIndexBig === 2 ? 0 : prevIndexBig + 1);
        }, 3000);
        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        const intervalSmall = setInterval(() => {
            setIndexSmall(prevIndexSmall => prevIndexSmall === 4 ? 0 : prevIndexSmall + 1);
        }, 3000);
        return () => clearInterval(intervalSmall);
    }, []);

    const isSmallScreenOrUnder = useMediaQuery(theme => theme.breakpoints.down("sm"));

    return (
        <Fragment>
            {isSmallScreenOrUnder ? (
                <Banner 
                    style={{backgroundImage: `url(${imagesForSmallScreen[indexSmall]})`}}
                >
                    <BannerText>
                        <Typography variant="h4" color="inherit">パンと</Typography>
                        <Typography variant="h4" color="inherit">おやつの店</Typography>
                        <Typography variant="h4" color="inherit">小麦屋</Typography>
                    </BannerText>
                </Banner>
            ) : (
                <Banner 
                    style={{backgroundImage: `url(${imagesForBigScreen[indexBig]})`}}
                >
                    <BannerText>
                        <Typography variant="h2" color="inherit">パンと</Typography>
                        <Typography variant="h2" color="inherit">おやつの店</Typography>
                        <Typography variant="h2" color="inherit">小麦屋</Typography>
                    </BannerText>
                </Banner>
            )}
        </Fragment>
    )
}

export default PhotosCarousel;